import React from "react";

import { IndividualDonePage } from "IndividualApplication/pages/IndividualDonePage";
import { IndividualEnterInformation } from "IndividualApplication/pages/IndividualEnterInformation";
import { SelectDentalPlanPage } from "IndividualApplication/pages/SelectDentalPlanPage";
import { SelectVisionPlanPage } from "IndividualApplication/pages/SelectVisionPlanPage";
import { createStore } from "IndividualApplication/redux";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

const App = () => {
  const store = createStore({});

  return (
    <Provider store={store}>
      <Switch>
        <Route path="/individual-application/dental-plans" children={<SelectDentalPlanPage />} />
        <Route path="/individual-application/vision-plans" children={<SelectVisionPlanPage />} />
        <Route path="/individual-application/enter-information" children={<IndividualEnterInformation />} />
        <Route path="/individual-application/done" children={<IndividualDonePage />} />
      </Switch>
    </Provider>
  );
};

export default App;
